export const EXTERNAL_TOKEN_KEY = 'TOKEN';
export const EXTERNAL_USER_KEY = 'USER';

export const PREVIEW_DELAY_TIME = 750;

export const INDENT_FOR_LW_IN_POPUP = 28;

export const TOUCH_SENSITIVE = Math.floor(window.devicePixelRatio || 0) * 50;
export const TOUCH_SENSITIVE_CAROUSEL = Math.floor(window.devicePixelRatio || 0) * 25;
